<template>
  <router-link
    :to="{name: 'hotel-management-reservations-detail-rooms-detail', params: {roomId: room.id}}"
    custom
    v-slot="{ navigate, isExactActive }"
  >
    <div @click="navigate" class="hm-rooms-link" :class="{'hm-rooms-link--active': isExactActive}">
      <div class="hm-rooms-link__title">
        <span class="hm-rooms-link__roomno">
          <template v-if="room.room">{{ room.room.short_name }}</template>
          <img v-else src="@/assets/img/hm/warning.svg" alt="">
        </span>
        <span class="hm-rooms-link__name">{{ room.short_room.room_category.name }}</span>
      </div>
      <div class="hm-rooms-link__dates">
        <CalendarIcon aria-hidden="true"/>
        <span>{{ fmtDate(room.short_room.check_in) }}</span>
        <ArrowIcon aria-hidden="true"/>
        <span>{{ fmtDate(room.short_room.check_out) }}</span>
      </div>
      <div class="hm-rooms-link__footer">
        <HMChipList>
          <HMChip>
            {{ room.short_room.nights || '0' }}
            <template #icon><NightsIcon aria-hidden="true" /></template>
          </HMChip>
          <HMChip
            v-if="room.reservation?.meal_plan?.name"
            :title="room.reservation.meal_plan.full_name"
            :color="room.reservation.meal_plan.color"
            isMeal
          >
            {{ room.reservation.meal_plan.name }}
          </HMChip>
          <HMChip v-if="room.short_room.accomodation_type?.age_assignment?.adult" color="#9AB992">
            {{ room.short_room.accomodation_type.age_assignment.adult }}
            <template #icon><AdultIcon aria-hidden="true" /></template>
          </HMChip>
          <HMChip v-if="room.short_room.accomodation_type?.age_assignment?.teenager" color="#76A9B4">
            {{ room.short_room.accomodation_type.age_assignment.teenager }}
            <template #icon><TeenagerIcon aria-hidden="true" /></template>
          </HMChip>
          <HMChip v-if="room.short_room.accomodation_type?.age_assignment?.child" color="#D493B0">
            {{ room.short_room.accomodation_type.age_assignment.child }}
            <template #icon><ChildIcon aria-hidden="true" /></template>
          </HMChip>
        </HMChipList>
        <HMBalance :balance="room.balance"/>
      </div>
    </div>
  </router-link>
</template>

<script>

import CalendarIcon from '@/views/hotel-management/reservations/detail/icons/CalendarIcon.vue'
import ArrowIcon from '@/views/hotel-management/reservations/detail/icons/ArrowIcon.vue'
import ChildIcon from '@/views/hotel-management/reservations/detail/icons/ChildIcon.vue'
import AdultIcon from '@/views/hotel-management/reservations/detail/icons/AdultIcon.vue'
import NightsIcon from '@/views/hotel-management/reservations/detail/icons/NightsIcon.vue'
import TeenagerIcon from '@/views/hotel-management/reservations/detail/icons/TeenagerIcon.vue'
import HMBalance from '@/views/hotel-management/reservations/components/HMBalance.vue'
import HMChipList from '@/views/hotel-management/reservations/components/HMChipList.vue'
import HMChip from '@/views/hotel-management/reservations/components/HMChip.vue'

export default {
  name: 'HMRoomsLink',
  props: {
    room: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    HMChip,
    HMChipList,
    HMBalance,
    TeenagerIcon,
    NightsIcon,
    AdultIcon,
    ChildIcon,
    ArrowIcon,
    CalendarIcon
  },
  methods: {
    fmtDate(iso) {
      if (!iso) return ''
      const d = new Date(`${iso}T00:00:00`)
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${d.getDate()} ${months[d.getMonth()]}`
    },
  }
}
</script>

<style scoped>
.hm-rooms-link {
  padding: 20px 20px 20px 30px;
  border-radius: 16px;
  border: 1px solid #E9E9E9;
  background-color: #FFF;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
  cursor: pointer;
  transition: border-color 0.3s;

  &:hover {
    border-color: #A3A3A3;
  }
}

.hm-rooms-link--active {
  border-color: #A3A3A3;
}

.hm-rooms-link__title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
}

.hm-rooms-link__roomno {
  color: #000;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
}

.hm-rooms-link__name {
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  font-weight: 500;
}

.hm-rooms-link__dates {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 19px;
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  line-height: 1;
  font-weight: 500;
}

.hm-rooms-link__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
</style>